export var CSRPostingTypes = [{
        id: '01',
        RegNo: 'MH12XC0158'
    }, {
        id: '02',
        RegNo: 'MH12TM5363'
    }, {
        id: '03',
        RegNo: 'MH12B9480'
    }];
